import React from 'react';
import PropTypes from 'prop-types';

import { colors } from '@styleseat/brand';
import {
  BodyText,
} from '../../../ui';

export const SignupCountdownText = ({ days }) => (
  <BodyText appearance="small" testID="signup-countdown-body">
    <BodyText appearance="small" color={colors.red} weight="bold">
      {`${days} day${days === 1 ? '' : 's'}`}
    </BodyText>
    {' left to complete these steps and keep your business listing active.'}
  </BodyText>
);

SignupCountdownText.propTypes = {
  days: PropTypes.number.isRequired,
};

export default SignupCountdownText;
